import { jsxs as a, jsx as e } from "react/jsx-runtime";
import s from "./list-header.module.less.js";
const t = ({ title: n, numberOfStations: l, icon: r, iconText: i }) => /* @__PURE__ */ a("div", { className: s.wrapper, children: [
  /* @__PURE__ */ a("h5", { className: `${s.title} mb-0`, children: [
    n,
    l && /* @__PURE__ */ e("span", { className: s.numberOfStations, children: `(${l})` })
  ] }),
  /* @__PURE__ */ a("div", { className: s.explanation, children: [
    r && /* @__PURE__ */ e("span", { className: [s.icon, r].join(" ") }),
    i && /* @__PURE__ */ e("p", { className: [s.iconText, "my-0 body-s"].join(" "), children: i })
  ] })
] });
export {
  t as ListHeader,
  t as default
};
